import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext<any>(null);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<any>(null);
  const [wishlist, setWishlist] = useState<string[]>([]);

  const loadWishlist = () => api.get("/wishlist").then((r) => setWishlist(r.data.product_ids)).catch(() => {});

  useEffect(() => {
    api.get("/auth/me").then((r) => { setUser(r.data); loadWishlist(); }).catch(() => setUser(false));
  }, []);

  const finish = (data: any) => {
    localStorage.setItem("sc_token", data.token);
    setUser(data.user);
    loadWishlist();
    return data.user;
  };
  const login = async (email: string, password: string) => finish((await api.post("/auth/login", { email, password })).data);
  const register = async (name: string, email: string, password: string) =>
    finish((await api.post("/auth/register", { name, email, password })).data);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("sc_token");
    setUser(false);
    setWishlist([]);
  };
  const toggleWish = async (id: string) => {
    if (!user) return false;
    if (wishlist.includes(id)) {
      setWishlist((w) => w.filter((x) => x !== id));
      await api.delete(`/wishlist/${id}`);
    } else {
      setWishlist((w) => [...w, id]);
      await api.post(`/wishlist/${id}`);
    }
    return true;
  };

  return (
    <AuthCtx.Provider value={{ user, setUser, login, register, logout, wishlist, toggleWish }}>{children}</AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
